import LogRocketDataSource from "../../../infrastructure/datasource/logrocket/LogRocketDataSource";

class IdentifyLogRocket {
  private readonly repository = new LogRocketDataSource();
  public execute(name: string) {
    this.repository.identify(name);
  }
}

export default IdentifyLogRocket;
